(function () {
  const popup = document.getElementById('ContactPopup');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'cp-popup-dismissed';
  const delaySec = Math.max(0, Number(popup.dataset.delay || 60));
  const delayMs = delaySec * 1000;
  const hideDays = Math.max(1, Number(popup.dataset.hideDays || 7));
  const showOnMobile = popup.dataset.showMobile !== 'false';
  const closeButtons = popup.querySelectorAll('[data-contact-popup-close]');
  const focusTarget = popup.querySelector('a, button');
  let openTimer = null;
  let timeSpentMs = 0;
  let pageEnterTime = null;
  let previouslyFocused = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isDismissed() {
    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return false;
      const until = Number(raw);
      if (!until || Number.isNaN(until)) return false;
      if (Date.now() > until) {
        localStorage.removeItem(storageKey);
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function rememberDismiss() {
    try {
      const until = Date.now() + hideDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(storageKey, String(until));
    } catch (e) {}
  }

  /**
   * Check if the newsletter popup is currently open.
   * The newsletter popup adds 'is-open' to #NewsletterPopup.
   */
  function isNewsletterOpen() {
    const nlPopup = document.getElementById('NewsletterPopup');
    return nlPopup ? nlPopup.classList.contains('is-open') : false;
  }

  function openPopup() {
    if (popup.classList.contains('is-open')) return;

    // Do not open if newsletter popup is visible
    if (isNewsletterOpen()) {
      // Retry after 5 seconds in case newsletter is dismissed
      openTimer = window.setTimeout(openPopup, 5000);
      return;
    }

    previouslyFocused = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cp-popup-open');
    window.setTimeout(() => focusTarget?.focus(), 50);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cp-popup-open');
    rememberDismiss();
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function shouldShow() {
    if (!showOnMobile && isMobile()) return false;
    return !isDismissed();
  }

  /**
   * Time-tracking approach:
   * - Record when user entered page (or tab became visible)
   * - Accumulate time while tab is visible
   * - Only trigger after delayMs of ACTIVE time
   */
  function startTimer() {
    if (!shouldShow()) return;
    pageEnterTime = Date.now();

    openTimer = window.setTimeout(() => {
      openPopup();
    }, Math.max(0, delayMs - timeSpentMs));
  }

  function pauseTimer() {
    if (pageEnterTime !== null) {
      timeSpentMs += Date.now() - pageEnterTime;
      pageEnterTime = null;
    }
    if (openTimer) {
      window.clearTimeout(openTimer);
      openTimer = null;
    }
  }

  function handleVisibilityChange() {
    if (document.hidden) {
      pauseTimer();
    } else {
      startTimer();
    }
  }

  // Close handlers
  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  // Listen for newsletter popup close so we can retry showing contact popup
  const nlPopupEl = document.getElementById('NewsletterPopup');
  if (nlPopupEl) {
    const nlObserver = new MutationObserver(() => {
      if (!nlPopupEl.classList.contains('is-open') && shouldShow() && !popup.classList.contains('is-open') && !openTimer) {
        // Newsletter was just closed, check if we've hit our time threshold
        if (timeSpentMs >= delayMs) {
          openPopup();
        }
      }
    });
    nlObserver.observe(nlPopupEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Start tracking time
  document.addEventListener('visibilitychange', handleVisibilityChange);

  function init() {
    if (!shouldShow()) return;
    if (!document.hidden) {
      startTimer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cleanup on unload
  window.addEventListener('pagehide', () => {
    if (openTimer) window.clearTimeout(openTimer);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });
})();
